import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { ArticlePicture } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';

export const trackScrollToUGC = (pictures: ArticlePicture[] = []) =>
  Gtm.push({
    event: 'interaction_display ratings on product page',
    e_category: 'navigation',
    e_action: 'display ratings on product page',
    e_label: undefined,
    event_trigger: 'product page',
    amp_event_name: 'Display ratings on product page',
    interaction_hit: 'False',
    review_picture_count: pictures.length,
    review_carousel_is_displayed: !!pictures.length,
  });
